export enum OpplistingTyperEnum {
  INGEN = 0,
  Henvisning = 1,
  Inklusjon = 2,
  Prøvesvar = 3,
  Koloskopirapport = 4,
  Henvendelse = 5,
  Henvisningssvar = 6,
}
